/**
 * @author PoornaChandu
 * @description  and added device and asset in the hierarchyModal
 */
import React , { useEffect,useState,useRef } from 'react';
import { connect } from 'react-redux';
// import moment from 'moment';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { constant,constants } from './Utils/constants';
import HierarchyModal from './Utils/HierarchyModal';
import localStorage from '../../utils/localStorage';
import {
  Button,
  Form,
  Select,
  Modal,
  DatePicker,
  Col,
  Row,
  message,
  Dropdown,
  Typography,
  Space,
  Input,
  Divider,
  Popconfirm,
  // Checkbox
} from 'antd';
import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  EyeOutlined,
  UpSquareOutlined
} from '@ant-design/icons';
import {
  // getParameterList,
  // getDeviceData,
  CreateTrend,
  getBookmarkList,
  getObservationList,
  UpdateTrends,
  getOperationList,
  DeleteTrend,
  DeleteObservation,
  getHierarchyLevels,
  getEquipmentList,
  getParametersList
} from './ChartCalls';
import './Utils/CSS/style.css';
import { IPAddress } from '../../commons/api';
import { getUserHeirarchyData } from '../Trends/ChartCalls';
import StyledTable from '../../commons/styles/table';
const { RangePicker } = DatePicker;
const { Option } = Select;
const FilterComponent = (props) => {
  const [Module, setModule] = useState('');
  const [bookmarkName, setBookmarkName] = useState([]);
  const [type, setType] = useState("live");
  const [checkedValue, setCheckedValue] = useState([]);
  const [selectedParameter, setSelectedParameter] = useState([]);
  const [selectedParameterType, setSelectedParameterType] = useState([]);
  const [Id, setId] = useState("");
  const [equipmentList, setEquipmentList] = useState([]);
  const [tunedData, setTunedData] = useState({});
  const CurrentTab = "day";
  const [bookmarkList, setBookmarkList] = useState([]);
  const [selectedInterval, setSelectedInterval] = useState(undefined);
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [hierarchyArray, setHierarchyArray] = useState([]);
  const [selectedFromDate_ToDate, setSelectedFromDate_ToDate] = useState([]);
  const [selectedFromDate_ToDate1, setSelectedFromDate_ToDate1] = useState([]);
  const [selectedDateRangeComparision, setSelectedDateRangeComparision] = useState([]);
  const [bookMark,setBookMark] = useState("");
  const [treeData, setTreeData] = useState([]);
  const [selectedHierarchy, setSelectedHierarchy] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(undefined);
  const [parameterList, setParameterList] = useState({});
  const [selectedDate, setSelectedDate] = useState([]);
  const [operationalList, setOperationalList] = useState({});
  const [observationList, setObservationList] = useState(props.obList || {});
  const [parameterListByType, setParameterListByType] = useState([]);
  const intervalList = constants && constants.frequencyList ? constants.frequencyList : [];
  const [treeVisible, setTreeVisible] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [currentTab, setCurrentTab] = useState('day');
  const [graphType, setGraphType] = useState(props.GraphType || 'line');
  const [viewType, setViewType] = useState('Single');
  const [userProfile, setUserProfile] = useState(props.userProfile);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  // const [expand, setExpand] = useState(false);
  const [isModalSaveBookmark, setIsModalSaveBookmark] = useState(false);
  const [isModalViewBookmark, setIsModalViewBookmark] = useState(false);
  const [isObservervationViewModal, setIsObservervationViewModal] = useState(false);
  // const [celd, setCeld] = useState(props.celd);
  const [selectedOption,setSelectedOption] = useState ('Device');
  const formHeader = useRef();
  const bookMarkRef = useRef();
  useEffect(() => {
    const fetchData = async () => {
      let equipmentList = await getEquipmentList();
      let HierarchyData = await getUserHeirarchyData();
      let permissionsArray =
        HierarchyData &&
        HierarchyData['belongsTo'] &&
        HierarchyData['belongsTo']['sites'] &&
        HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
        HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];
      onHierarchySelect(permissionsArray[0].HierarchyName);
      let BookmarkList = await getBookmarkList();
      let ObservationList = await getObservationList();
      setHierarchyArray(permissionsArray);
      setEquipmentList(equipmentList);
      setBookmarkList(BookmarkList);
      setObservationList(ObservationList);
    };
    fetchData();
  }, []);
  const onHierarchySelect = async (Modules) => {
    let treeData = await getHierarchyLevels(Modules);
    // setSelectedHierarchy(Modules);
    // setSelectedDevice([]);
    setSelectedParameter([]);
    setSelectedParameterType([]);
    setSelectedOperator([]);
    // setCheckedValue([]);
    setTreeData(treeData);
    setModule(Modules);
  };
  useEffect(() => {
    if (props.translationCache !== translationCache || props.userProfile !== userProfile) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }
    if (props.obList !== observationList) {
      setObservationList(props.obList);
    }
  }, [props.translationCache, props.userProfile, props.obList]);
  const generateData = (tunedData, deviceList) => {
    const siteId = localStorage.get('currentSite');
    let Operator = '';
    selectedParameterType === 'Operational' ? (Operator = 'AVG') : (Operator = 'FIRST'); 
    let allData = [
      {
        ...tunedData,
        SiteId: siteId,
        GraphType:graphType,
        Operator,
        CodeType:selectedOption
      }
    ];
    let data =
      tunedData && tunedData.ParameterList && Array.isArray(tunedData.ParameterList)
        ? tunedData.ParameterList.map((param) => {
          let value = '';
              if (selectedOption === 'Device') {
                value =
                  deviceList && Array.isArray(deviceList)
                    ? deviceList
                        .filter((d) => param.ParameterCode === d.ParameterCode)
                        .map((dev) => {
                          return dev.DeviceName;
                        })
                    : '';
              } else {
                value =
                  deviceList && Array.isArray(deviceList)
                    ? deviceList
                        .filter((d) => param.ParameterCode === d.ParameterCode)
                        .map((dev) => {
                          return dev.AssetName;
                        })
                    : '';
              }
            return {
              ...tunedData,
              ParameterList: [param],
              Operator,
              CodeType:selectedOption,
              ParameterName:
                deviceList && Array.isArray(deviceList)
                  ? deviceList
                      .filter((d) => param.ParameterCode === d.ParameterCode)
                      .map((dev) => {
                        return dev.ParameterName;
                      })
                  : '',
              SiteId: siteId,
              GraphType: graphType,
              ...(selectedOption === 'Device'
                ? { DeviceName: value || '' }
                : { AssetName: value || '' })
            };
          })
        : '';
    props.generateData(data, allData);
  };
  dayjs.extend(utc);
  const trendAdapter = () => {
    let payload = {
      Type: type,
      ViewType:viewType,
      ParameterList: selectedParameter.map((deviceParameter) => {
        let spliteData = deviceParameter.split('@@');
        if (selectedOption === 'Device') {
          return {
            DeviceCode: spliteData[0],
            ParameterCode: spliteData[1]
          };
        } else {
          return {
            AssetCode: spliteData[0],
            ParameterCode: spliteData[1]
          };
        }
      }),
      selectedHierarchy
    };
    if (selectedParameterType === 'Operational' && type !== 'live') {
      payload.Operator = selectedOperator;
      payload.GraphType = graphType;
    }
    if (
      selectedParameterType === 'Fault' &&
      type !== 'live' &&
      (selectedOperator === 'FIRST' || selectedOperator === 'LAST' || selectedOperator === 'RAW')
    ) {
      payload.Operator = selectedOperator;
      payload.GraphType = 'Table';
    }
    if (type === 'live') {
      payload.GraphType = graphType;
    }
    if (type === 'historic') {
      payload.Interval = selectedInterval;
      payload.FromDate = dayjs(selectedFromDate_ToDate1[0]).utc().format('YYYY-MM-DD HH:mm:ss');
      payload.ToDate = dayjs(selectedFromDate_ToDate1[1]).utc().format('YYYY-MM-DD HH:mm:ss');
    } else if (type === 'timeRange') {
      payload.FromDate1 = dayjs(selectedFromDate_ToDate[0]).utc().format('YYYY-MM-DD HH:mm:ss');
      payload.ToDate1 = dayjs(selectedFromDate_ToDate[1]).utc().format('YYYY-MM-DD HH:mm:ss');
      payload.FromDate2 = dayjs(selectedDateRangeComparision[0]).utc().format('YYYY-MM-DD HH:mm:ss');
      payload.ToDate2 = dayjs(selectedDateRangeComparision[1]).utc().format('YYYY-MM-DD HH:mm:ss');
      payload.Interval = selectedInterval;
    } else if (type === 'timeWithSelectionType') {
      payload.FromDate = dayjs(selectedFromDate_ToDate1[0]).utc().format('YYYY-MM-DD HH:mm:ss');
      payload.ToDate = dayjs(selectedFromDate_ToDate1[1]).utc().format('YYYY-MM-DD HH:mm:ss');
      payload.Interval = selectedInterval;
      payload.SelectionType = CurrentTab;
    }
    return payload;
  };
  const OnGenerateTrendData = async () => {
    formHeader.current
      .validateFields()
      .then(async () => {
        const tunedData = trendAdapter();
        let filteredDeviceList = parameterListByType.filter((a) =>
          tunedData.ParameterList.some((s) => s.ParameterCode === a.ParameterCode)
        );
        selectedParameter &&
          Array.isArray(selectedParameter) &&
          selectedParameter.length > 0 &&
          selectedParameter.map((deviceParameter) => {
            let spliteData = deviceParameter.split('@@');
            return {
              DeviceCode: spliteData[0],
              ParameterCode: spliteData[1]
            };
          });
        generateData(tunedData, filteredDeviceList);
        setTunedData(tunedData);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onModalsOk = (e) => {
    e.preventDefault();
    OnDeviceChange(checkedValue);
    setTreeVisible(false);
  };
  const onModalCancel = () => {
    setTreeVisible(false);
    if(selectedDevice && Array.isArray(selectedDevice)&& selectedDevice.length > 0){
      setCheckedValue(selectedDevice);
    }else{
    setCheckedValue([]);
  }
  };
  const OnDeviceChange = async (value) => {
    const siteId = localStorage.get('currentSite');
    let val = [];
    val.push(value);
    let ParameterList = {};
    if (selectedOption === 'Asset') {
      if (value.length === 6) {
        value.shift();
        let payload = {
          AssetCode: val,
          SiteId: siteId,
          CodeType: 'Asset'
        };
        ParameterList = await getParametersList(payload);
      } else {
        if (value.length === 6) {
          let payload = {
            DeviceCode: val,
            SiteId: siteId,
            CodeType: 'Device'
          };
          value.shift();
          ParameterList = await getParametersList(payload);
        } else {
          let payload = {
            DeviceCode: val,
            SiteId: siteId,
            CodeType: 'Device'
          };
          ParameterList = await getParametersList(payload);
        }
      }
    } else {
      ParameterList = await getParametersList({DeviceCode:val,
        CodeType: selectedOption,
        SiteId: siteId});
    }
    setSelectedDevice(value);
    setParameterList(ParameterList);
    setOperationalList({});
    setSelectedParameterType(undefined);
    setSelectedParameter([]);
    setSelectedOperator(undefined);
    formHeader.current.setFieldsValue({
      selectedDevice: value,
      ParameterList :parameterList,
      update: false,
      ParameterListByType: [],
      selectedParameterType: undefined,
      selectedParameter: [],
      selectedOperator: undefined
    });
  };
  const hierarchyDropdownChange = (value) => {
    setCheckedValue(value);
  };
  const OnParameterChange = (value) => {
    if (type === 'timeRange' && value.length === 2) {
      value.shift();
      setSelectedParameter(value);
    } else if (type === 'timeWithSelectionType' && value.length === 2) {
      value.shift();
      setSelectedParameter(value);
    } else if (value.length === 11) {
      value.shift();
      setSelectedParameter(value);
    } else {
      setSelectedParameter(value);
    }
  };
  // const OnOperatorChange = (value) => {
  //   setSelectedOperator(value);
  // };
  // const OnHierarchyChange = (value) => {
  //   setSelectedHierarchy(value);
  // };
  const OnParameterTypeChange = async (selectedParameterType) => {
    // let { ParameterList, OperationalList, selectedOperator } = props; // Assuming these are passed as props
    if (selectedParameterType === 'Fault' && type !== 'live') {
     let OperationalList = await getOperationList(
        selectedParameterType,
        'Table',
        selectedOption
      );
      // setFieldVisible(true);
      setOperationalList(OperationalList);
      props.OperatorList(OperationalList);
    }
    if (
      selectedParameterType !== 'Operational' ||
      (selectedParameterType === 'Fault' && type === 'live')
    ) {
      // setFieldVisible(false);
      setSelectedOperator('');
    } else if (selectedParameterType === 'Operational' && type !== 'live') {
       let OperationalList = await getOperationList(
        selectedParameterType,
        'line',
        selectedOption
      );
      // setFieldVisible(true);
      setOperationalList(OperationalList);
      setSelectedOperator(selectedOperator);
      props.OperatorList(operationalList);
    }
    setParameterListByType(parameterList[selectedParameterType]);
    setSelectedParameterType(selectedParameterType);
    setSelectedParameter([]);
    setSelectedOperator(undefined);
    formHeader.current.setFieldsValue({
      selectedParameterType,
      selectedParameter: [],
      selectedOperator: undefined
    });
  };
  const OnTypeChange = (value) => {
    let ViewType = value && (value === 'timeRange' || value === 'timeWithSelectionType') ? 'Multiple' : 'Single';
    setType(value);
    setTunedData({});
    // setLoading(false);
    // setTrendData([]);
    setViewType(ViewType);
    setGraphType('line');
    setCheckedValue([]),
    setSelectedDevice([]);
    setSelectedParameter([]);
    setSelectedParameterType([]);
    setSelectedInterval('');
    setSelectedFromDate_ToDate([]);
    setSelectedFromDate_ToDate1([]);
    setSelectedDateRangeComparision([]);
    formHeader.current.setFieldsValue({
      type: value,
      ViewType:ViewType,
      selectedDevice: [],
      selectedParameter: [],
      selectedParameterType: [],
      selectedInterval: '',
      selectedFromDate_ToDate: [],
      selectedFromDate_ToDate1: [],
      selectedDateRangeComparision: [],
      Devices: ['value2'],
      checkedValue: []
    });
  };
  const OnResetFields = () => {
    formHeader.current.setFieldsValue({
      type: 'historic',
      Module: '',
      selectedDevice: [],
      selectedParameter: [],
      selectedOperator: undefined,
      selectedParameterType: [],
      selectedInterval: undefined,
      selectedFromDate_ToDate: [],
      selectedFromDate_ToDate1: [],
      selectedDateRangeComparision: [],
      ViewType: 'Single',
      fieldVisible: true,
      GraphType: 'line',
      selectedHierarchy: 'value3',
      Devices: ['value2']
    });
    setType('historic');
    setBookmarkName([]);
    setSelectedDevice([]);
    setSelectedParameter([]);
    setSelectedOperator(undefined);
    setSelectedParameterType([]);
    setSelectedInterval(undefined);
    setSelectedFromDate_ToDate1([]);
    setSelectedDateRangeComparision([]);
    // setObservationName(undefined);
    setId(undefined);
    setViewType('Single');
    // setFieldVisible(true);
    setGraphType('line');
    setSelectedHierarchy({});
    // setDevices([]);
    props.generateData({}, {});
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const onChangeFromDate_ToDate1 = (value, selectedFromDate_ToDate1String) => {
    setSelectedDevice(selectedDevice);
    setParameterList(parameterList);
    setParameterListByType(parameterListByType);
    const selectedFromDate_ToDate1 = [
        dayjs(selectedFromDate_ToDate1String[0]).utc().format('YYYY-MM-DD HH:mm:ss'),
        dayjs(selectedFromDate_ToDate1String[1]).utc().format('YYYY-MM-DD HH:mm:ss')
    ];
    setSelectedFromDate_ToDate1(selectedFromDate_ToDate1);
    let fromDate = dayjs(selectedFromDate_ToDate1String[0]);
    let toDate = dayjs(selectedFromDate_ToDate1String[1]);
    let diffInDays = toDate.diff(fromDate, 'day');
    if (diffInDays && diffInDays > 45) {
        message.error('Please select days within 45 days');
        setSelectedFromDate_ToDate1([
            dayjs(selectedFromDate_ToDate1String[0]).utc().format('YYYY-MM-DD HH:mm:ss'),
            null
        ]);
    } else if (diffInDays && diffInDays === 1) {
        formHeader.current &&
            formHeader.current.setFieldsValue({
                selectedInterval: '1h'
            });
        setSelectedInterval('1h');
    } else if (diffInDays && diffInDays >= 7) {
        formHeader.current &&
            formHeader.current.setFieldsValue({
                selectedInterval: '1d'
            });
        setSelectedInterval('1d');
    } else {
        // Handle other cases if needed
    }
};
  const disabledDate = (current) => {
    if (!selectedDate) {
      return false;
    }
    let after = selectedDate[0] && current.diff(selectedDate[0], 'days') > 45;
    let before = selectedDate[1] && selectedDate[1].diff(current, 'days') > 45;
    return !!before || !!after;
  };
  const onCalendarChange = (val) => {
    setSelectedDate(val);
  };
  const onBookmarkListOpen = () => {
    setIsModalViewBookmark(true);
  };
  const deleteObservation = async (record) => {
    let deleteResponse = await DeleteObservation(record.Id);
    if (deleteResponse && deleteResponse.message) {
      message.success(translation(deleteResponse.message));
      let ObservationList = await getObservationList();
      setObservationList(ObservationList);
    }
  };
  const onBookmarkModalOpen = () => {
    bookMarkRef.current &&
      bookMarkRef.current.setFieldsValue({
        BookmarkName: ''
      });
    setIsModalSaveBookmark(true);
    setBookMark('');
  };
  const onBookmarkSave = async () => {
    const siteId = localStorage.get('currentSite');
    let val = [];
    val.push(checkedValue);
    if (bookMark && bookMark.length > 0) {
      let payload = {
        Devices: checkedValue,
        Interval: selectedInterval,
        HierarchyCode: Module,
        Name: bookMark,
        Parameters: selectedParameter,
        ParameterType: selectedParameterType,
        Payload: {
          ...tunedData,
          CodeType:selectedOption
        },
        SiteId: siteId,
        Type: type,
        ViewType: viewType,
        Operator: selectedOperator
      };
      let saveBookmarkResponse = await CreateTrend(payload);
      if (saveBookmarkResponse && saveBookmarkResponse.message) {
        message.success(translation(saveBookmarkResponse.message));
        setBookmarkName(bookMark);
        let BookmarkList = await getBookmarkList(Module);
        setBookmarkList(BookmarkList);
        setIsModalSaveBookmark(false);
      }
    } else {
      message.warning(translation('Please input Bookmark name'));
    }
  };
  const deleteBookmark = async (record) => {
    let deleteResponse = await DeleteTrend(record.Id);
    if (deleteResponse && deleteResponse.message) {
      message.success(translation(deleteResponse.message));
      let BookmarkList = await getBookmarkList(Module);
      setBookmarkList(BookmarkList);
    }
  };
  const updateBookmark = async () => {
    const siteId = localStorage.get('currentSite');
    let payload = {
      Devices: selectedDevice,
      Interval: selectedInterval,
      HierarchyCode: Module,
      Name: bookmarkName,
      Parameters: selectedParameter,
      ParameterType: selectedParameterType,
      Payload: {
        ...tunedData,
        CodeType: selectedOption
      },
      SiteId: siteId,
      Type: type,
      ViewType: viewType,
      Id: Id,
      Operator: selectedOperator
    };
    let updateBookmarkResponse = await UpdateTrends(payload);
    if (updateBookmarkResponse && updateBookmarkResponse.message) {
      message.success(translation(updateBookmarkResponse.message));
      let BookmarkList = await getBookmarkList(Module);
      setBookmarkList(BookmarkList);
    }
  };
  const editBookmark = async (editObject) => {
    const siteId = localStorage.get('currentSite');
    let equipmentList = await getHierarchyLevels(editObject && editObject.HierarchyCode);
    let val = [];
    val.push(editObject.Devices);
    let ParameterList = {};
    let OperationalList = {};
    let ParameterListByType = [];
    if (editObject.Devices) {
      if (
        editObject &&
        editObject.Payload &&
        editObject.Payload.CodeType &&
        editObject.Payload.CodeType === 'Device'
      ) {
       let payload = {
          DeviceCode: val,
          SiteId: siteId,
          CodeType: editObject.Payload.CodeType
        };
        ParameterList = await getParametersList(payload);
      } else {
        let payload = {
          AssetCode: val,
          SiteId: siteId,
          CodeType: editObject.Payload.CodeType
        };
        ParameterList = await getParametersList(payload);
      }
      ParameterListByType = ParameterList[editObject.ParameterType];
      if (editObject.ParameterType === 'Fault' && editObject.Type !== 'live') {
        OperationalList = await getOperationList(
          editObject.ParameterType,
          'Table',
          editObject.Payload.CodeType
        );
      } else if (editObject.ParameterType === 'Operational' && editObject.Type !== 'live') {
        OperationalList = await getOperationList(
          editObject.ParameterType,
          graphType,
          editObject.Payload.CodeType
        );
        ParameterList = await getParametersList({
          CodeType: editObject.Payload.CodeType,
          [`${editObject.Payload.CodeType}Code`]: val,
          SiteId: siteId
      });      }
    }
    props.OperatorList(OperationalList);
    setType(editObject.Type);
    setSelectedHierarchy(editObject.HierarchyCode);
    setCheckedValue(editObject.Devices);
    setSelectedOption(editObject.Payload.CodeType),
    setSelectedDevice(editObject.Devices);
    setEquipmentList(equipmentList);
    setSelectedParameter(editObject.Parameters);
    setSelectedParameterType(editObject.ParameterType);
    setSelectedInterval(editObject.Interval);
    setSelectedDateRangeComparision([
      dayjs.utc(editObject.Payload.FromDate, 'YYYY-MM-DD HH:mm:ss').local(),
      dayjs.utc(editObject.Payload.ToDate, 'YYYY-MM-DD HH:mm:ss').local()
    ]);
    setIsModalViewBookmark(false);
    setViewType(editObject.ViewType);
    setSelectedOperator(editObject.Operator);
    setId(editObject.Id);
    setBookmarkName(editObject.Name);
    setSelectedFromDate_ToDate([
      dayjs.utc(editObject.Payload.FromDate, 'YYYY-MM-DD HH:mm:ss').local(),
      dayjs.utc(editObject.Payload.ToDate, 'YYYY-MM-DD HH:mm:ss').local()
    ]);
    setSelectedFromDate_ToDate1([
      dayjs.utc(editObject.Payload.FromDate, 'YYYY-MM-DD HH:mm:ss').local(),
      dayjs.utc(editObject.Payload.ToDate, 'YYYY-MM-DD HH:mm:ss').local()
    ]);
    setParameterList(ParameterList);
    setParameterListByType(ParameterListByType);
    setOperationalList(OperationalList);
    formHeader.current.setFieldsValue({
      type: editObject.Type,
      hierarchy: editObject.HierarchyCode,
      selectedDevice: editObject.Devices,
      selectedParameter: editObject.Parameters,
      selectedParameterType: editObject.ParameterType,
      selectedInterval: editObject.Interval,
      checkedValue: editObject && editObject.Devices,
      selectedDateRangeComparision: [
        dayjs.utc(editObject.Payload.FromDate, 'YYYY-MM-DD HH:mm:ss').local(),
        dayjs.utc(editObject.Payload.ToDate, 'YYYY-MM-DD HH:mm:ss').local()
      ],
      ViewType: editObject.ViewType,
      selectedOperator: editObject.Operator,
      selectedFromDate_ToDate: [
        dayjs.utc(editObject.Payload.FromDate, 'YYYY-MM-DD HH:mm:ss').local(),
        dayjs.utc(editObject.Payload.ToDate, 'YYYY-MM-DD HH:mm:ss').local()
      ],
      selectedFromDate_ToDate1: [
        dayjs.utc(editObject.Payload.FromDate, 'YYYY-MM-DD HH:mm:ss').local(),
        dayjs.utc(editObject.Payload.ToDate, 'YYYY-MM-DD HH:mm:ss').local()
      ]
    });
  };
  const renderFormSwitch = (name) => {
    switch (name) {
      case 'type':
        return (
          <Form.Item
            name={'type'}
            label={translation('Select Trend Type')}
            rules={[{ required: true, message: translation('Please Select TrendType!') }]}
          >
            <Select
              placeholder={translation('Select Trend Type')}
              onChange={OnTypeChange}
              style={{ width: '330px' }}
            >              
            {/* <Option value="live">{this.translation('Live Trend')}</Option> */}
              <Option value="historic">{translation('Historical Trend')}</Option>
            </Select>
          </Form.Item>
        );
      case 'hierarchy':
        return (
          <Form.Item
            name={'hierarchy'}
            label={translation('Select Hierarchy')}
            rules={[{ required: true, message: translation('Please Hierarchy!') }]}
          >
            <Select
              style={{ width: '330px' }}
              value={selectedHierarchy}
              placeholder={translation('Please Hierarchy')}
              onChange={onHierarchySelect}
            >
              {hierarchyArray &&
                Array.isArray(Object.keys(hierarchyArray)) &&
                Object.keys(hierarchyArray).map((device, index) => {
                  return (
                    <Option key={index} value={hierarchyArray[device].HierarchyCode}>
                      {hierarchyArray[device].HierarchyName}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        );
      case 'selectedDevice':
        return (
          <Form.Item
            name={'selectedDevice'}
            label={translation('Select Device')}
            rules={[{ required: true, message: translation('Please Select Equipment!') }]}
          >
            <span
              style={{
                display: 'flex',
                justifyContent: 'flex-start'
              }}
            >
              <Select
                style={{ width: '284px' }}
                value={selectedDevice}
                mode="multiple"
                placeholder={translation('Select Device')}
                disabled={true}
              >
                {equipmentList &&
                  Array.isArray(equipmentList) &&
                  equipmentList.map((eqp, index) => {
                    return (
                      <Option key={index} value={eqp.AliasCode}>
                        {`${eqp.DisplayCode}`}
                      </Option>
                    );
                  })}
              </Select>
              <Button
                type="primary"
                onClick={() => {
                  setTreeVisible(true);
                }}
              >
                <UpSquareOutlined />
              </Button>
            </span>
          </Form.Item>
        );
      case 'selectedParameterType':
        return (
          <Form.Item
            name={'selectedParameterType'}
            label={translation('Select Parameter Type')}
            rules={[{ required: true, message: translation('Please Select Parameter Type!') }]}
          >
            <Select
              style={{ width: '330px' }}
              value={selectedParameterType}
              placeholder={translation('Select Parameter Type')}
              onChange={OnParameterTypeChange}
            >
              {parameterList &&
                Array.isArray(Object.keys(parameterList)) &&
                Object.keys(parameterList).map((parameterType) => {
                  return <Option key={parameterType}>{parameterType}</Option>;
                })}
            </Select>
          </Form.Item>
        );
        case 'selectedParameter':
          return (
            <Form.Item
              name={'selectedParameter'}
              label={translation(constant.Select_Parameter)}
              rules={[{ required: true, message: translation('Please Select Parameter!') }]}
            >
              <Select
                style={{ width: '330px' }}
                showSearch
                mode="multiple"
                value={selectedParameter}
                onChange={OnParameterChange}
                placeholder={translation(constant.Select_Parameter)}
              >
                {parameterListByType &&
                  Array.isArray(parameterListByType) &&
                  parameterListByType.map((param, index) => {
                    const isDevice = selectedOption === 'Device';
                    const value = isDevice ? `${param.Device}@@${param.ParameterCode}` : `${param.Asset}@@${param.ParameterCode}`;
                    const name = isDevice ? `${param.DeviceName}=>${param.ParameterDescription}` : `${param.AssetName}=>${param.ParameterDescription}`;
                    const isDisabled = formHeader &&
                      formHeader.current &&
                      formHeader.current.getFieldsValue() &&
                      formHeader.current.getFieldsValue().selectedParameter &&
                      formHeader.current.getFieldValue().selectedParameter.length === 3
                      ? formHeader.current
                          .getFieldValue()
                          .selectedParameter.includes(value)
                        ? false
                        : true
                      : false;
                    return (
                      <Option key={index} value={value} disabled={isDisabled}>
                        {name}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          );
      case 'selectedFromDate_ToDate1':
        return (
          <Form.Item
            name={'selectedFromDate_ToDate1'}
            label={translation('Select Range')}
            rules={[
              {
                required: false,
                message: translation('Please Select DateRanges!')
              }
            ]}
          >
            <RangePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              style={{ width: '330px' }}
              placeholder={[translation('Start DateTime'), translation('End DateTime')]}
              value={selectedFromDate_ToDate1}
              onChange={onChangeFromDate_ToDate1}
              onCalendarChange={(val) => onCalendarChange(val)}
              disabledDate={(d) =>
                !d ||
                d.isAfter(
                  dayjs().add(1, 'day').format('YYYY-MM-DD'),
                  disabledDate(d)
                )
              }
              changeOnBlur={true}
            />
          </Form.Item>
        );
      case 'selectedInterval':
        return (
          <Form.Item
            name={'selectedInterval'}
            label={translation('Interval')}
            rules={[{ required: true, message: translation('Please Select Interval!') }]}
          >
            <Select
              placeholder={translation('Interval')}
              value={selectedInterval}
              onChange={setSelectedInterval}
              style={{ width: '330px' }}
            >
              {intervalList &&
                Array.isArray(intervalList) &&
                intervalList.map((item, index) => {
                  return (
                    <Option key={index} value={item.value}>
                      {item.label}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        );
      default:
        return <div>{name}</div>;
    }
  };
    let permissionsArray = [];
    userProfile &&
      userProfile['belongsTo'] &&
      userProfile['belongsTo']['sites'] &&
      userProfile['belongsTo']['sites'][localStorage.get('currentSite')] &&
      userProfile['belongsTo']['sites'][localStorage.get('currentSite')]['role'] &&
      userProfile['belongsTo']['sites'][localStorage.get('currentSite')]['role']['Permission']
        .filter((item) => item.resource === 'trends')
        .map((name) => permissionsArray.push(name.action));
        const getFields = () => {
          let fields = [
            'type',
            'hierarchy',
            'selectedDevice',
            'selectedParameterType',
            'selectedParameter',
            ...(type === 'historic' ? ['selectedFromDate_ToDate1', 'selectedInterval'] : [])
          ];
          return fields.map((colName) => (
            <div style={{ width: '350px' }} key={colName}>
              {renderFormSwitch(colName)}
            </div>
          ));
        };
       const  onChange = (checkedValues) => {
          setSelectedOption(checkedValues);
        };
        const items = [
          {
            key: Id ? 'update' : 'save',
            label: Id ? 'Update bookmark' : 'Save bookmark'
          },
          {
            key: 'list',
            label: 'View bookmarks'
          }
        ];
        const columns = [
          {
            title: translation('Bookmark Name'),
            dataIndex: 'Name',
            key: 'Name',
            width: 150
          },
          {
            title: translation('Type'),
            dataIndex: 'Type',
            key: 'Type',
            width: 150
          },
          {
            title: translation('Devices'),
            dataIndex: 'Devices',
            key: 'Devices',
            width: 150
          },
          {
            title: translation('Parameters'),
            dataIndex: 'Parameters',
            key: 'Parameters',
            width: 150
          },
          {
            title: translation('Parameter Type'),
            dataIndex: 'ParameterType',
            key: 'ParameterType',
            width: 150
          },
          {
            title: translation('View Type'),
            dataIndex: 'ViewType',
            key: 'ViewType',
            width: 150
          },
          {
            title: translation('Actions'),
            dataIndex: '',
            key: '',
            width: 150,
            render: (text, record) => (
              <span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${IPAddress.LOCAL}/rubus/ViewTrends/${record.Id}`}
                >
                  <EyeOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                      editBookmark(record);
                    }}
                  />
                </a>
                <Divider type="vertical" />
                <EditOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    editBookmark(record);
                  }}
                />
                <Divider type="vertical" />
                <Popconfirm
                  title={translation('Are you sure delete the trend?')}
                  placement="top"
                  onConfirm={(e) => {
                    e.stopPropagation();
                    deleteBookmark(record);
                  }}
                  onCancel={(e) => {
                    e.stopPropagation();
                  }}
                  okText={translation('Yes')}
                  cancelText={translation('No')}
                >
                  <DeleteOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Popconfirm>
              </span>
            )
          }
        ];
        const columnsData = [
          {
            title: translation('Observation Name'),
            dataIndex: 'Name',
            key: 'Name',
            width: 150
          },
          {
            title: translation('Observation Feedback'),
            dataIndex: 'Comments',
            key: 'Comments',
            width: 150
          },
          {
            title: translation('Parameter'),
            dataIndex: 'Parameter',
            key: 'Parameter',
            width: 150
          },
          {
            title: translation('Date Time'),
            dataIndex: 'DateTime',
            key: 'DateTime',
            width: 150,
            render: (text) => ({
              children: text ? (
                <div>{dayjs(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
            })
          },
          {
            title: translation('Actions'),
            dataIndex: '',
            key: '',
            width: 150,
            render: (text, record) => (
              <span>
                <Popconfirm
                  title={translation('Are you sure delete the Observation?')}
                  placement="top"
                  onConfirm={(e) => {
                    e.stopPropagation();
                    deleteObservation(record);
                  }}
                  onCancel={(e) => {
                    e.stopPropagation();
                  }}
                  okText={translation('Yes')}
                  cancelText={translation('No')}
                >
                  <DeleteOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Popconfirm>
              </span>
            )
          }
        ];
    return (
      <div style={{ background: 'rgb(38, 60, 83)', padding: '30px', marginTop: '8px' }}>
      {bookmarkName && Array.isArray(bookmarkName) && bookmarkName.length === 0 ? (
        null
      ) : <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '13px',
        
        color: '#fff',
      }}
    >
      {translation('Bookmark')}: {bookmarkName}
    </div>}
      <div style={{ display: 'flex', flexDirection: 'row-reverse', marginBottom: '10px' }}>
        <Dropdown
          menu={{
            items,
            selectable: true,
            onClick: (e) => {
              if (e.key === 'list') {
                onBookmarkListOpen();
              } else if (e.key === 'save') {
                formHeader.current
                  .validateFields()
                  .then(async () => {
                    onBookmarkModalOpen();
                  })
                  .catch(() => {
                    message.warning(translation('Please input mandatory fields to save bookmark'));
                  });
              } else if (e.key === 'update') {
                formHeader.current
                  .validateFields()
                  .then(async () => {
                    updateBookmark();
                  })
                  .catch(() => {
                    message.warning(translation('Please input mandatory fields to update bookmark'));
                  });
              }
            },
          }}
        >
          <Typography.Link>
            <Space>
              {translation(constant.Bookmark_Options)}
              <DownOutlined />
            </Space>
          </Typography.Link>
        </Dropdown>
        <div style={{ display: 'flex', flexDirection: 'row', marginRight: '10px' }}>
          <Button
            onClick={() => {
              setIsObservervationViewModal(true);
            }}
          >
            {translation(constant.Observation_List)}
          </Button>
        </div>
      </div>
      <Form
        ref={formHeader}
        initialValues={{}} 
        layout={'vertical'}
        className="FormDarkMode"
        onFinish={OnGenerateTrendData}
      >
        <div style={{ display: 'flex', flexFlow: 'row wrap' }}>{getFields()}</div>
        <Row>
          <Col
            span={24}
            style={{
              textAlign: 'right',
            }}
          >
            <Button type="primary" htmlType="submit">
              {translation('Save and Generate')}
            </Button>
            <Button
              style={{
                margin: '0 8px',
              }}
              onClick={() => {
                OnResetFields();
              }}
            >
              {translation('Reset')}
            </Button>
          </Col>
        </Row>
      </Form>
      <Modal
        width={'900'}
        title={translation('View Bookmarks')}
        open={isModalViewBookmark}
        onOk={() => setIsModalViewBookmark(false)}
        onCancel={() => setIsModalViewBookmark(false)}
        footer={[
          <Button key="back" onClick={() => setIsModalViewBookmark(false)}>
            {translation('Cancel')}
          </Button>,
        ]}
      >
        <StyledTable size="small" dataSource={bookmarkList} columns={columns} scroll={{ x: 120, y: 550 }} />
      </Modal>
      <Modal
        width={'900'}
        title={translation('View Observations')}
        open={isObservervationViewModal}
        onOk={() => setIsObservervationViewModal(false)}
        onCancel={() => setIsObservervationViewModal(false)}
        footer={[
          <Button key="back" onClick={() => setIsObservervationViewModal(false)}>
            {translation('Cancel')}
          </Button>,
        ]}
      >
        <StyledTable size="small"
          dataSource={
            observationList && Array.isArray(observationList) && observationList.length > 0
              ? observationList
              : []
          }
          columns={columnsData}
          scroll={{ x: 120, y: 550 }}
        />
      </Modal>
      <Modal
        open={treeVisible}
        width={800}
        closable
        title={translation('Select Equipment')}
        okText={translation('Add')}
        onOk={onModalsOk}
        onCancel={onModalCancel}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <div style={{marginRight:40}}>
          <Button onClick={() => onChange('Device')} style={{marginRight:20}}>
            Device
          </Button>
          <Button onClick={() => onChange('Asset')}>
            Asset
          </Button>
        </div>
        <HierarchyModal
          selectedDevice={checkedValue}
          treeData={Object.values(treeData)}
          Key="Trends"
          handleDropdownChange={hierarchyDropdownChange}
          selectedOption={selectedOption}
        />
        </div>
      </Modal>
      <Modal
        title={translation(constant.Save_Bookmark)}
        open={isModalSaveBookmark}
        onOk={onBookmarkSave}
        onCancel={() => {
          setIsModalSaveBookmark(false);
          setBookMark('');
        }}
        footer={[
          <Button key="back" onClick={() => {
            setIsModalSaveBookmark(false);
            setBookMark('');
          }}>
            {translation('Cancel')}
          </Button>,
          <Button key="submit" type="primary" onClick={onBookmarkSave}>
            {translation(constant.Save_Bookmark)}
          </Button>,
        ]}
      >
        <Form layout="vertical" ref={bookMarkRef}>
          <Form.Item
            name={'BookmarkName'}
            label={translation(constant.BookmarkName)}
            rules={[{ required: true, message: translation('Input Bookmark!') }]}
          >
            <Input onChange={(e) => setBookMark(e.target.value)} />
          </Form.Item>
        </Form>
      </Modal>
      
      </div>
    );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});
export default connect(mapStateToProps)(FilterComponent);
